import { useTable, type TableOptions } from '@tanstack/react-table';

import { features, type DataTableFeatures } from 'src/component/ds/ui/dataTableFeatures';

import type { DsAnyRow } from 'src/component/ds/dataTable/types';

export type UseDsTableOptions<TData extends DsAnyRow> =
  Omit<TableOptions<DataTableFeatures, TData>, 'features' | 'getSubRows' | 'getRowId'>;

/**
 * `useTable` preset for DsDataTable: shadcn features, `children` as sub-rows,
 * `id` as row id, and manual sorting, filtering and pagination.
 *
 * @param {UseDsTableOptions<TData>} options TanStack table options; override the defaults
 * @returns {ReactTable<DataTableFeatures, TData>} the table to pass to `DsDataTable`
 */
export function useDsTable<TData extends DsAnyRow> (options: UseDsTableOptions<TData>) {
  return useTable({
    features,
    getSubRows: (row: TData) => row.children as TData[] | undefined,
    getRowId: (row: TData) => row.id,
    manualSorting: true,
    manualFiltering: true,
    manualPagination: true,
    ...options,
  });
}
